export default class AuthForm {
    constructor(selector = '#auth') {
        const authEl = document.querySelector(selector) || null;

        if (!authEl) {
            return;
        }

        this.authEl = authEl;
        this.loginWrap = authEl.querySelector('[data-ref="login-wrap"]');
        this.verificationWrap = authEl.querySelector('[data-ref="verification-wrap"]');
        this.errorPhoneMessageEl = authEl.querySelector('[data-error-message="phone"]');
        this.errorLoginMessageEl = authEl.querySelector('[data-error-message="login"]');
        this.errorPassMessageEl = authEl.querySelector('[data-error-message="pass"]');
        this.errorMessageEl = authEl.querySelector('[data-error-message="common"]');
        this.sessionErrorMessage = authEl.querySelector('[data-display-type="session_error"]');
        this.authForm = authEl.querySelector('[data-form-id="login"]');
        this.verificationForm = this.authEl.querySelector('[data-form-type="verification"]') || null;
        this.failedMessageEl = this.authEl.querySelector('[data-ref="message-wrap"]') || null;
        this.authFormType = null;
        this.validationError = true;
        this.formInputs = this.authForm.querySelectorAll('input:not([type="radio"])');
        this.telInput = this.authForm.querySelector('#auth-phone');
        this.loginNameInput = this.authForm.querySelector('#login-name');
        this.loginPassInput = this.authForm.querySelector('#login-pass');
        this.codeInputs = this.verificationForm.querySelectorAll('[data-auth="code-input"]');
        this.currentPhoneElem = this.verificationForm.querySelector('[data-ref="current-phone"]');
        this.triesElem = this.verificationForm.querySelector('[data-ref="tries"]');
        this.verificationTelInput = this.verificationForm.querySelector('#verification-phone');
        this.verificationFormMessageEl = this.verificationForm.querySelector('[data-auth-form="verify-message"]');
        this.timerIntervalId = null;
        this.verificationRoute = null;

        this.initLoginForm();
        this.initVerificationForm();
    }

    fetch(route, options) {
        return fetch(route, {
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            },
            ...options,
        });
    }

    async submit(action, options) {
        const preloader = document.querySelector('[data-ui-el="popup-preloader"]');

        this.clearErrorMessage();
        preloader.classList.add('active');

        const response = await this.fetch(action, options);

        if (response.status === 419) {
            preloader.classList.remove('active');
            this.sessionErrorMessage.setAttribute('style', 'display:block');

            return;
        }

        preloader.classList.remove('active');

        const result = await response.json();

        if (response.status === 422 || response.status === 400) {
            if (result?.messages?.phone?.length > 0) {
                this.showErrorMessage(this.errorPhoneMessageEl, result.messages.phone[0]);
                return;
            }

            if (result?.messages?.login?.length > 0) {
                this.showErrorMessage(this.errorLoginMessageEl, result.messages.login[0]);
                return;
            }

            if (result?.messages?.password?.length > 0) {
                this.showErrorMessage(this.errorPassMessageEl, result.messages.password[0]);
                this.showErrorMessage(this.errorLoginMessageEl, '');
                return;
            }

            if (result?.messages?.code?.length > 0) {
                this.showVerificationMessage('#error-verification-message', result.messages.code[0]);
                return;
            }

            if (result.data?.message?.length > 0) {
                this.showVerificationMessage('#error-verification-message', result.data.message);
            } else {
                console.log(result);
            }
        }

        if (response.status === 403 || response.ok || response.status === 400) {
            if (result.data.state === 'check') {
                this.verificationRoute = this.authForm.dataset.checkAction || this.verificationRoute;
                this.verificationFormActive(result.data);
                return;
            }

            if (result.data.state === 'done') {
                this.hideVerificationForm();
                this.validationError = true;
                this.verificationRoute = this.authForm.dataset.checkAction;
                return;
            }

            if (result.data.state === 'not-confirmed') {
                this.showFailedMessagePopup(result.data.phone, result.data.waitTime);
                return;
            }
        }

        if (response.ok || response.status === 401) {
            if (result?.data?.redirect) {
                window.location.assign(result.data.redirect);
                return;
            }

            window.location.reload();
        } else {
            console.log(response);
        }
    }

    initLoginForm() {
        if (!this.authForm) {
            return;
        }

        const authTypeBtn = this.authForm.querySelectorAll('[data-auth-type-input]');

        [...authTypeBtn].forEach((input) => {
            this.authFormType = this.switchAuthType(input);
            this.switchRequiredField(this.authFormType);

            input.addEventListener('change', () => {
                this.authFormType = this.switchAuthType(input);
                this.switchRequiredField(this.authFormType);
                this.validationRequiredInput(this.formInputs);
            });
        });

        if (this.telInput) {
            this.telInput.addEventListener('blur', () => {
                this.telInput.value = this.telInput.value.length > 5 ? this.telInput.value : '';
            });
        }

        [...this.formInputs].forEach((input) => {
            input.addEventListener('input', () => {
                this.validationRequiredInput(this.formInputs);
            });
        });

        this.authForm.onsubmit = (event) => {
            event.preventDefault();

            if (this.validationRequiredInput(this.formInputs)) {
                return;
            }

            this.submit(this.authForm.action, {
                body: new FormData(this.authForm),
            });
        }
    }

    initVerificationForm() {
        if (!this.verificationForm) {
            return;
        }

        [...this.codeInputs].forEach((input, index) => {
            input.addEventListener('input', () => {
                const { value } = input;

                if (input.value === '' && index > 0) {
                    this.codeInputs[index].value = '';
                    this.codeInputs[index - 1].focus();
                    this.validationRequiredInput(this.codeInputs);
                }

                if (value.length > 1) {
                    input.value = value[0];

                    [...value.slice(1)].forEach((val, i) => {
                        const k = 1 + i + index;

                        if (k >= this.codeInputs.length) {
                            this.validationRequiredInput(this.codeInputs);
                            return;
                        }

                        this.codeInputs[k].value = val;
                        this.codeInputs[k].focus();
                        this.validationRequiredInput(this.codeInputs);
                    });
                }
            });
        });

        this.verificationForm.onsubmit = (event) => {
            event.preventDefault();
            const formData = new FormData(this.verificationForm);
            const code = [...this.codeInputs].map(input => input.value).join('');

            this.verificationRoute = this.verificationRoute || this.verificationForm.action;
            formData.append('code', code);

            this.submit(this.verificationRoute, {
                body: formData,
            });
        }

        this.verificationForm.onclick = (event) => {
            const resendButton = event.target.closest('[data-auth-resend]');

            if (resendButton) {
                this.submit(resendButton.dataset.authResend, {
                    body: new FormData(this.verificationForm),
                });
            }
        }
    }

    verificationFormActive ({ phone = '', lifeTime = 60, tries = 4, state = null }) {
        if (!this.currentPhoneElem || !this.triesElem || state !== 'check') {
            return;
        }

        this.clearInputs(this.codeInputs);
        this.verificationForm.classList.remove('time-error');
        this.currentPhoneElem.textContent = phone;
        this.verificationTelInput.value = phone;
        this.triesElem.textContent = tries;
        this.showVerificationForm();

        this.timer(lifeTime, () => {
            this.showVerificationMessage('#error-verification-message', 'Час вийшов');
            this.verificationForm.classList.add('time-error');
        });
    }

    showVerificationForm() {
        this.loginWrap.setAttribute('hidden', '');
        this.verificationWrap.removeAttribute('hidden');
    }

    hideVerificationForm() {
        this.verificationWrap.setAttribute('hidden', '');
        this.failedMessageEl.classList.remove('show');
        this.loginWrap.removeAttribute('hidden');
        this.resetVerificationForm();
    }

    resetVerificationForm() {
        if (this.timerIntervalId) {
            clearInterval(this.timerIntervalId);
        }

        this.currentPhoneElem.innerHTML = '';
        this.triesElem.innerHTML = '';
        this.verificationTelInput.value = '';
    }

    clearInputs (inputsArr = []) {
        inputsArr.forEach(input => {
            input.value = '';
            input.parentElement.classList.remove('is-invalid');
        });
    }

    validationRequiredInput(inputs) {
        const requiredInputs = Array.from(inputs).filter(input => input.hasAttribute('data-required')) || null;
        const emptyInput = requiredInputs.find(input => input.value.trim() === '') || null;
        const phoneInput = requiredInputs.find(input => input.value.trim().length < 19 && input.id === 'auth-phone') || null;
        const validateInput = phoneInput || emptyInput;

        if (validateInput && !this.validationError) {
            this.validationError = true;
            validateInput.closest('form').querySelector('button[type="submit"]').setAttribute('disabled', '');
        } else if (!validateInput && this.validationError) {
            this.validationError = false;
            inputs[0].closest('form').querySelector('button[type="submit"]').removeAttribute('disabled');
        }

        return this.validationError;
    }

    switchAuthType(input) {
        if (input.checked) {
            this.authForm.dataset.formType = input.dataset.authTypeInput;
            return input.dataset.authTypeInput;
        }
    }

    switchRequiredField(formType) {
        if (formType === 'webspark') {
            this.loginNameInput.setAttribute('data-required', '');
            this.loginPassInput.setAttribute('data-required', '');
            this.telInput.removeAttribute('data-required');
        } else {
            this.loginNameInput.removeAttribute('data-required');
            this.loginPassInput.removeAttribute('data-required');
            this.telInput.setAttribute('data-required', '');
        }
    }

    timer (lifeTime = 60, callback) {
        this.showVerificationMessage('#timer');

        const timeElem = document.querySelector('[data-ref="life-time"]');

        if (!timeElem) {
            return;
        }

        timeElem.textContent = this.formattingTime(lifeTime);
        timeElem.parentElement.removeAttribute('hidden');

        this.timerIntervalId = setInterval(() => {
            lifeTime--;
            timeElem.textContent = this.formattingTime(lifeTime);

            if (lifeTime <= 0) {
                clearInterval(this.timerIntervalId);

                return typeof(callback) === 'function' ? callback() : null;
            }
        }, 1000);
    }

    formattingTime(value) {
        const minutes = Math.floor(value / 60);
        const seconds = value % 60;

        return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    }

    formattingWaitTime (waitTime) {
        if (typeof waitTime !== 'number') {
            return '';
        }

        const allMinutes = Math.floor(waitTime / 60);
        let hours = Math.floor(allMinutes / 60);
        let minutes = allMinutes % 60;

        hours = this.formattingTimeWords(hours, ['годину', 'години', 'годин']);
        minutes = this.formattingTimeWords(minutes, ['хвилину', 'хвилини', 'хвилин']);

        return `${hours} ${minutes}`;
    }

    formattingTimeWords (time, forms = []) {
        if (typeof time !== 'number' && forms.length === 0) {
            return '';
        }

        const reminder = time % 10;
        const number = time < 10 ? `0${time}` : time;

        switch (reminder) {
            case 1:
                return `${number} ${forms[0]}`;
            case 2:
            case 3:
            case 4:
                return `${number} ${forms[1]}`;
            default:
                return `${number} ${forms[2]}`;
        }
    }

    showErrorMessage(elem, message) {
        elem.innerHTML = message;
        elem.parentElement.classList.add('is-invalid');
    }

    clearErrorMessage() {
        const errorMessages = document.querySelectorAll('[data-error-message]');

        [...errorMessages].forEach(item => {
            item.innerHTML = '';
            item.parentElement.classList.remove('is-invalid');
        });
    }

    showVerificationMessage(tempId, message = null) {
        if (!tempId) return;

        const temp = document.querySelector(tempId);
        const tempContent = document.createDocumentFragment();

        tempContent.appendChild(temp.content.cloneNode(true));

        if (this.timerIntervalId) {
            clearInterval(this.timerIntervalId);
        }

        if (message) {
            this.validationRequiredInput(this.codeInputs);
            this.verificationForm.classList.add('time-error');
            tempContent.querySelector('[data-ref="verification-message"]').textContent = message.toString();
        }

        this.verificationFormMessageEl.innerHTML = '';
        this.verificationFormMessageEl.appendChild(tempContent);
    }

    showFailedMessagePopup (phone = '', waitTime = 86400) {
        const failedMessage = this.authEl.querySelector('[data-ref="failed-message"]');

        if (!failedMessage || !this.failedMessageEl) {
            return;
        }

        const time = this.formattingWaitTime(waitTime);

        failedMessage.textContent = `Підтвердити номер ${phone} Ви зможете через ${time}`;
        this.failedMessageEl.classList.add('show');
        this.verificationWrap.setAttribute('hidden', '');
        this.loginWrap.setAttribute('hidden', '');
    }
}
